import axios from 'axios';

import { AUS_API_ENDPOINT } from 'constants/api';

const ausAPI = axios.create({
  baseURL: AUS_API_ENDPOINT,
});

export default ausAPI;
